angular.module('angus.controllers').controller('pricePlanProfAnalysisSubRegSettingsCtrl', [
    '$scope', 'promiseMonitor', 'productsService',
    function($scope, promiseMonitor, productsService) {

        $scope.promiseMonitor = new promiseMonitor();

        var promise = productsService.getProducts($scope.subscriberId)
            .then(function(products) {
                $scope.products = products;               
            });

        $scope.promiseMonitor.monitor(promise);
    }
]);